import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../../shared/types/api.types'
import { getOfferRequestTripDetailsForAdminApi } from './getOfferRequestTripDetailsForAdmin.api'
import getOfferRequestTripDetailsForAdminInitialState from './getOfferRequestTripDetailsForAdmin.initialState'
import {
  GetOfferRequestTripDetailsForAdminErrorResponse,
  GetOfferRequestTripDetailsForAdminRequestPayload
} from './getOfferRequestTripDetailsForAdmin.types'

export const getOfferRequestTripDetailsForAdmin = createAsyncThunk(
  urls.admin.getOfferRequestTripDetailsForAdmin,
  async (payload: GetOfferRequestTripDetailsForAdminRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await getOfferRequestTripDetailsForAdminApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse, undefined, true)

      return rejectWithValue(error)
    }
  }
)

const getOfferRequestTripDetailsForAdminSlice = createSlice({
  name: urls.admin.getOfferRequestTripDetailsForAdmin,
  initialState: getOfferRequestTripDetailsForAdminInitialState,
  reducers: {
    resetGetOfferRequestTripDetailsForAdmin: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }

    // Add any additional reducers here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOfferRequestTripDetailsForAdmin.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(getOfferRequestTripDetailsForAdmin.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(getOfferRequestTripDetailsForAdmin.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as GetOfferRequestTripDetailsForAdminErrorResponse
        state.success = null
      })
  }
})

export const {
  actions: getOfferRequestTripDetailsForAdminActions,
  reducer: getOfferRequestTripDetailsForAdminReducer
} = getOfferRequestTripDetailsForAdminSlice
export const { resetGetOfferRequestTripDetailsForAdmin } = getOfferRequestTripDetailsForAdminActions
export default getOfferRequestTripDetailsForAdminSlice.reducer
